<template>
  <img
    :src="imgUrl"
    :width="size"
    :height="size"
    class="photo-icon"
    :title="title"
  />
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'HMImageIcon',
  props: {
    image: {
      type: Object,
      required: false,
    },
    size: {
      type: String,
      default: '25px',
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    imgUrl() {
      return this.image?.url || '/assets/images/default-instructor-photo.png';
    },
  },
});
</script>

<style lang="scss" scoped>
.photo-icon {
  vertical-align: center;
  object-fit: cover;
  border-radius: 50%;
}
</style>
